<!-- TODO TODO TODO -->

<!--
     <Chart
       type="type_string"
       title="My title"
       :chardata="chardata"
       description=''
     >
-->

<template>
  <div class="chart-cont">
    <h2 class="chart-title">{{ title }}</h2>
    <div class="chart-chart" >
      <component
        :is="type"
        :title="title"
        :subtitle="subtitle"
        :chardata="chardata"
      />
    </div>
    <p class="chart-description" v-if="!!description">{{ description }}</p>
  </div>
</template>


<style lang="scss">
 @import "@/sass/variables.scss";

 .chart-cont {
   width: 100%;
   height: 100%;
   min-width: 100px;
   min-height: 100px;
   display: flex;
   flex-direction: column;
   border-radius: 10px;
 }

 .chart-title {
   color: $primary;
   padding-left: 1em;
   padding-right: 1em;
   text-align: center;
 }

 .chart-chart {
   width: 100%;
   height: 100%;
 }
</style>


<script>
//  import { computed } from 'vue';
//  import BarChart from './BarChart';
//  import PieChart from './PieChart';
//  import LineChart from './LineChart';
//  import DatesHeatChart from './DatesHeatChart';
//  import MultiChart from './MultiChart';
//  import GaugeChart from './GaugeChart';
//  import TableChart from './TableChart';

//  const CHART_TYPE = {
//    'BarChart': BarChart,
//    'PieChart': PieChart,
//    'LineChart': LineChart,
//    'DatesHeatChart': DatesHeatChart,
//    'MultiChart': MultiChart,
//    'GaugeChart': GaugeChart,
//    'TableChart': TableChart,
//  };

 export default {
   name: 'Chart',

   props: {
     type: {required: true},
     title: {required: false, default: ''},
     subtitle: {required: false, default: ''},
     chardata: {required: true},
     description: {required: false, default: ''},
   },

   components: {
    BarChart: () => import('@/components/charts/BarChart'),
     PieChart: () => import('@/components/charts/PieChart'),
     LineChart: () => import('@/components/charts/LineChart'),
     LineDatetimeChart: () => import('@/components/charts/LineDatetimeChart'),
     DatesHeatChart: () => import('@/components/charts/DatesHeatChart'),
     MultiChart: () => import('@/components/charts/MultiChart'),
     TableChart: () => import('@/components/charts/TableChart'),
   },
   
   data: (() => ({
     // patata
   })),

   computed: {
     my_component() {
       return CHART_TYPE[this.type];
     },
   },
 };
</script>
